<template>
  <div>
    <v-dialog
      v-model="show"
      width="500"
      height="800"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      scrollable
      style="overflow-y: hidden"
    >
      <v-overlay absolute v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="#2d8cff" class="mr-2 my-2" />
      </v-overlay>
      <v-card style="background: #fff; overflow-y: hidden" v-else>
        <v-card-title
          :class="tradeFormColor"
          style="color: white; font-weight: 800"
        >
          {{ tradeTypeText }}
          <v-spacer></v-spacer>
          <v-icon
            text
            @click="toggleTradeModal({ show: false })"
            color="#fff"
            large
            style="cursor"
            >mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text
          :class="type === 'copy' ? 'px-2 pt-2' : 'px-2 pt-10'"
          style="overflow-x: hidden"
        >
          <v-form ref="tradeForm" @submit.prevent="openReviewTrade">
            <v-row>
              <v-col
                cols="12"
                style="background: #edf3fb"
                :class="$vuetify.breakpoint.smAndUp ? 'py-2 pl-7' : 'py-2 pl-6'"
                v-if="type === 'copy'"
              >
                <div class="copyOrigin" @click="goToProfile(copyDetail)">
                  <span
                    style="
                      font-family: 'Avenir';
                      font-style: normal;
                      font-weight: 400;
                      font-size: 12px;
                      line-height: 16px;

                      color: #4f4f4f;
                    "
                    >Trade origin</span
                  >
                  {{ copyDetail.posted_by_name }}
                </div>
              </v-col>
              <v-col
                cols="12"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-7' : 'pl-6'"
              >
                <label>Trade Type<span class="label">*</span></label>
                <v-radio-group
                  v-model="trade_type_seg"
                  :disabled="is_trade_update"
                  row
                >
                  <div v-for="(item, i) in trade_type_list" :key="i">
                    <v-radio :label="item.name" :value="item.value"></v-radio>
                  </div>
                </v-radio-group>
              </v-col>
              <v-col cols="8" md="9" class="text__col">
                <!-- {{ securityData }} -->
                <label> Security<span class="label">*</span> </label>
                <v-autocomplete
                  placeholder="Type security name"
                  outlined
                  hide-no-data
                  loader-height="2"
                  :loading="isSearching"
                  :disabled="is_trade_update || is_copy_trade"
                  v-model="securityData"
                  :search-input.sync="security"
                  item-text="name"
                  :filter="customFilter"
                  item-value="id"
                  height="46"
                  :items="securities"
                  cache-items
                  @change="getLivePrice"
                  class="text__field"
                  return-object
                >
                  <template slot="item" slot-scope="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.name }} - {{ data.item.symbol }} -
                    {{ data.item.exchange }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="4" md="3" class="text__col">
                <label
                  ><span :class="switchValue ? '' : 'buyStatusClass'">Buy</span>
                  |
                  <span :class="switchValue ? 'sellStatusClass' : ''"
                    >Sell</span
                  ></label
                >
                <div class="d-flex text-center align-center pt-3">
                  <!-- <span
                    class="pr-2"
                    :class="trade_type == 'Buy' ? 'buy-title' : ''"
                  >
                    Buy
                  </span> -->
                  <!-- <v-switch
                    color="#eb5757"
                    class="custom-switch"
                    v-model="switchValue"
                    light
                    inset
                    @change="setTradeType()"
                  ></v-switch> -->
                  <label class="toggle">
                    <input
                      class="toggle-checkbox"
                      type="checkbox"
                      @change="setTradeType()"
                      :disabled="is_copy_trade"
                      v-model="switchValue"
                    />
                    <div class="toggle-switch"></div>
                  </label>
                  <!-- <span
                    class="pl-2"
                    :class="trade_type == 'Sell' ? 'sell-title' : ''"
                    >Sell</span
                  > -->
                </div>
              </v-col>
              <v-col cols="8" md="9" class="text__col">
                <label class="d-flex"
                  >Entry Price<span class="label">*</span>
                  <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
                  <order-type-comp
                    v-model="orderType"
                    v-if="trade_type_seg === 'real'"
                  ></order-type-comp>
                </label>
                <v-text-field
                  outlined
                  type="number"
                  :rules="rules"
                  @input="checkPrice"
                  v-model.number="entry_price"
                  placeholder="Enter Entry Price"
                  class="text__field"
                >
                  <!-- //entryPriceSellRule, -->
                </v-text-field>
              </v-col>
              <v-col cols="4" md="3" class="text__col">
                <div
                  class="live-price-div d-flex align-center justify-space-between pt-11"
                >
                  <div class="text-center">
                    <label>Live Price</label>
                    <div>
                      <span
                        class="livePriceClass"
                        v-html="sec_live_price ? ` ₹${sec_live_price}` : ''"
                      >
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="8" md="9" class="text__col">
                <label>Lots<span class="label">*</span> </label>
                <v-text-field
                  outlined
                  type="number"
                  :rules="rules"
                  @input="checkPrice"
                  v-model="lots"
                  hide-spin-buttons
                  placeholder="Enter the lots"
                  class="text__field"
                >
                  <!-- //entryPriceSellRule, -->
                </v-text-field>
              </v-col>
              <v-col cols="4" md="3" class="text__col">
                <div
                  class="live-price-div d-flex align-center justify-space-between pt-11"
                >
                  <div class="text-center">
                    <label>Investment</label>
                    <div>
                      <span class="livePriceClass" v-text="entry_price * lots">
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" class="text__col">
                <v-row
                  v-for="(target_stop_loss, index) in target_stop_loss_list"
                  :key="index"
                >
                  <v-col
                    cols="5"
                    md="5"
                    :style="index > 0 ? 'margin-top:-15px' : ''"
                  >
                    <div
                      class="d-flex"
                      v-if="index == 0 && trade_type_seg === 'real'"
                    >
                      <label>Exit Price<span class="label">*</span></label>
                      <v-spacer></v-spacer>
                      <div class="stoploss_type__class text-right">
                        <span v-if="orderType === 'market_order'"
                          >SL-M Order</span
                        >
                        <span v-else>SL order</span>
                      </div>
                    </div>
                    <v-text-field
                      outlined
                      type="number"
                      @input="checkPrice"
                      :rules="index > 0 ? '' : rules"
                      hide-spin-buttons
                      v-model.number="target_stop_loss.target_price"
                      placeholder="Target Price"
                      class="text__field"
                    >
                      <template v-slot:label>
                        <div style="color: #828282 !important">
                          Target Price
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="5"
                    md="5"
                    :style="index > 0 ? 'margin-top:-15px' : ''"
                  >
                    <div
                      class="stoploss_type__class text-right"
                      v-if="index == 0 && trade_type_seg === 'real'"
                    >
                      <span v-if="orderType === 'market_order'">
                        SL-M Order
                      </span>
                      <span v-else>SL order</span>
                    </div>
                    <v-text-field
                      outlined
                      type="number"
                      :rules="index > 0 ? '' : rules"
                      hide-spin-buttons
                      @input="checkPrice"
                      v-model.number="target_stop_loss.stop_loss"
                      placeholder="Stop Loss"
                      class="text__field"
                    >
                      <template v-slot:label>
                        <div style="color: #828282 !important">Stop Loss</div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="2" v-if="index > 0">
                    <v-btn
                      text
                      @click="removeTrailingStopLoss(index)"
                      style="
                        min-wdth: 10px !important;
                        padding: 0 10px;
                        margin-top: 5px;
                      "
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                class="pl-3 mb-3 d-flex py-0"
                style="
                  background: rgba(0, 0, 0, 0.02);
                  border: 1px solid rgba(0, 0, 0, 0.12);
                "
              >
                <v-btn
                  @click="addNewTrailingStoploss"
                  color="primary"
                  text
                  style="font-weight: 900"
                  max-width="100%"
                  class="pa-0"
                >
                  <span
                    style="font-size: 12px; text-transform: none"
                    class="text-decoration-underline"
                  >
                    Add intermediate targets to enable trailing stop loss
                  </span>
                </v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon right v-bind="attrs" v-on="on" color="#828282">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>
                    <!-- By adding multiple targets, the target price will be the
                    next stop loss. so, you can make profit. -->
                    As intermediate targets are achieved, the previous target
                    acts as a stop loss to secure unrealised profits.
                  </span>
                </v-tooltip>
              </v-col>
              <!-- <v-col cols="12" md="12" class="text__col">
                <label>Duration<span class="label">*</span></label>
                <v-select
                  placeholder="Select Duration "
                  outlined
                  item-text="name"
                  return-object
                  item-value="id"
                  :disabled="is_trade_update"
                  :rules="rules"
                  v-model="duration"
                  :items="duration_list"
                  class="text__field"
                >
                </v-select>
              </v-col> -->
              <v-col cols="12" md="12" class="text__col">
                <label
                  >Duration<span class="label">*</span
                  ><span>
                    <v-tooltip
                      max-width="300"
                      content-class="tooltip"
                      color="#F7FAFF"
                      right
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="pb-1 pl-1" v-bind="attrs" v-on="on"
                          >mdi-information-outline</v-icon
                        >
                      </template>
                      <span class="tooltip-text"
                        >Intra-day/BTST (1~2 days) <br
                      /></span>
                      <span class="tooltip-text"
                        >Swing (few days/weeks) <br
                      /></span>
                      <span class="tooltip-text"
                        >Long term (months/years) <br
                      /></span>
                    </v-tooltip>
                  </span>
                </label>
                <v-radio-group v-model="duration" row class="py-0">
                  <div v-for="(item, i) in duration_list" :key="i">
                    <v-radio
                      :label="item.name_to_show"
                      :value="item.id"
                      class="px-0 py-0"
                      v-if="item.name !== 'Short term (1~2 weeks)'"
                    ></v-radio>
                  </div>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="text__col"
                style="margin-top: -30px"
              >
                <label>Reasoning<span class="label"></span></label>
                <v-text-field
                  outlined
                  :disabled="is_trade_update"
                  v-model="reasoning"
                  placeholder="Enter trade reasoning"
                  class="text__field"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="12" class="text__col mb-5">
                <div>
                  <review-and-post-trade-visibility
                    v-if="$featureFlags.groups"
                    v-model="visibility"
                    :flag="switchValue"
                    :groupId="groupId"
                  ></review-and-post-trade-visibility>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="pl-5 pr-5 mt-5"
                :class="
                  $vuetify.breakpoint.xsOnly
                    ? 'd-flex justify-center'
                    : 'd-flex justify-end'
                "
              >
                <!-- <v-btn
                  :style="`border: 1px solid ${titleBtnColor}`"
                  :class="`text-${titleBtnColor} save__btn px-5`"
                  v-if="!is_trade_update"
                  @click="postRealTrade"
                  :loading="realTradeLoading"
                  :disabled="formLoading"
                >
                  <span :style="`color:${titleBtnColor}`">
                    Post real trade
                  </span>
                </v-btn> -->
                <v-btn
                  v-if="!is_trade_update && !is_copy_trade"
                  :color="titleBtnColor"
                  class="save__btn"
                  :width="$vuetify.breakpoint.xsOnly ? '100%' : ''"
                  @click="submitBtnHandler"
                  :loading="formLoading"
                  :disabled="realTradeLoading"
                  >Post trade
                </v-btn>
                <v-btn
                  class="save__btn"
                  :color="titleBtnColor"
                  :width="$vuetify.breakpoint.xsOnly ? '100%' : ''"
                  @click="updateTrade"
                  v-else-if="is_trade_update && !is_copy_trade"
                >
                  Update trade
                </v-btn>
                <v-btn
                  class="save__btn"
                  :color="titleBtnColor"
                  :width="$vuetify.breakpoint.xsOnly ? '100%' : ''"
                  @click="submitBtnHandler"
                  v-else
                >
                  Post trade
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Axios from "@/api/BaseAxios.js";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "TradeForm",
  props: {
    groupId: { type: String, default: null },
    trade_form_data: { type: Object },
    filter_by: { type: String },
  },
  components: {
    ReviewAndPostTradeVisibility: () =>
      import("./ReviewAndPostTradeVisibility.vue"),
    OrderTypeComp: () => import("./OrderTypeComp/OrderTypeComp.vue"),
  },
  data: () => ({
    trade_type: "Buy",
    security: "",
    loading: false,
    groupLoad: false,
    formLoading: false,
    realTradeLoading: false,
    securityData: null,
    hideOverlay: false,
    fullscreen: false,
    securities: [],
    entry_price: null,
    target_price: null,
    duration: null,
    duration_list: [],
    stop_loss: null,
    isSearching: false,
    reasoning: null,
    sec_live_price: null,
    sec_close_price: null,
    sec_percent: null,
    duration_name: null,
    rules: [],
    tradeRules: {},
    entryPriceBuyRule: [],
    entryPriceSellRule: [],
    exitPriceBuyRule: [],
    exitPriceSellRule: [],
    stopLossBuyRule: [],
    stopLossSellRule: [],
    visibility: {
      postTo: "followers",
      groupId: null,
    },
    trade_type_seg: "virtual",
    trade_type_list: [
      { name: "Virtual Trade", value: "virtual" },
      { name: "Real Trade", value: "real" },
    ],
    switchValue: false,
    target_stop_loss_list: [
      {
        target_price: null,
        stop_loss: null,
      },
    ],
    trade_data: {},
    lots: 1,
    orderType: "market_order",
  }),
  computed: {
    ...mapGetters({
      tradeShow: "tradeData/getShow",
    }),
    show: {
      get() {
        return this.tradeShow;
      },
      set(value) {
        return this.toggleTradeModal({ show: value });
      },
    },
    type() {
      return this.$store.state.tradeData.showModal.type;
    },
    copyDetail() {
      return this.$store.state.tradeData.showModal.copyTradeDetail;
    },
    trade_id() {
      return this.$store.state.tradeData.showModal.id;
    },
    tradeFormColor() {
      if (this.trade_type == "Buy") {
        return "title-color-buy";
      } else {
        return "title-color-sell";
      }
    },
    priceUpDownPercent() {
      return (
        ((this.sec_live_price - this.sec_close_price) / this.sec_close_price) *
        100
      ).toFixed(2);
    },
    priceUpDown() {
      return (this.sec_live_price - this.sec_close_price).toFixed(1);
    },
    titleBtnColor() {
      if (this.trade_type == "Buy") {
        return "#2d8cff";
      } else {
        return "#eb5757";
      }
    },
    is_trade_update() {
      if (this.type === "edit") {
        return true;
      } else {
        return false;
      }
    },
    is_copy_trade() {
      if (this.type === "copy") {
        return true;
      } else {
        return false;
      }
    },
    tradeTypeText() {
      switch (this.type) {
        case "add":
          return "Add Trade";
        case "edit":
          return "Update Trade";
        case "copy":
          return "Add Trade";
        default:
          return "Add Trade";
      }
    },
  },
  watch: {
    show(value) {
      if (value) {
        setTimeout(() => {
          this.openModal();
        }, 300);
      } else {
        this.closeModal();
      }
    },
    orderType: function () {
      // this.setEntryPrice()
    },
    security: function (val) {
      if (!val || val.length == 0) {
        this.securities = [];
        return;
      }

      // Items have already been loaded
      // if (this.securities.length > 0) return;

      // Items have already been requested
      if (this.isSearching) return;

      this.isSearching = true;
      if (!this.securityData) {
        this.isSearching = false;
      }
      // Lazily load input items
      console.log("searching");
      const successHandler = (res) => {
        console.log(res.data, "securities");
        this.securities = res.data;
        // console.log(this.securities, "loiaded");
        setTimeout(() => {
          this.isSearching = false;
        }, 2000);
      };
      const errorHandler = (err) => {
        console.log(err.statusText);
        this.showSnack({
          text: `${err.statusText}`,
          color: "error",
          timeout: 4500,
        });
        this.isSearching = false;
      };
      Axios.request_GET(
        `api/trade/security_search/${val}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
      toggleTradeModal: "tradeData/toggleModal",
    }),
    openModal() {
      if (this.filter_by === "real") {
        this.trade_type_seg = "real";
      }
      this.groupLoad = true;
      this.getDurationList();
    },
    closeModal() {
      this.trade_data = {};
      this.trade_type = "Buy";
      this.lots = 1;
      this.security = "";
      this.groupLoad = false;
      this.loading = false;
      this.formLoading = false;
      this.securityData = null;
      this.hideOverlay = false;
      this.fullscreen = false;
      this.securities = [];
      this.entry_price = null;
      this.target_price = null;
      this.duration = null;
      this.duration_list = [];
      this.stop_loss = null;
      this.isSearching = false;
      this.reasoning = null;
      this.sec_live_price = null;
      this.sec_close_price = null;
      this.sec_percent = null;
      this.duration_name = null;
      this.rules = [];
      this.tradeRules = {};
      this.entryPriceBuyRule = [];
      this.entryPriceSellRule = [];
      this.exitPriceBuyRule = [];
      this.exitPriceSellRule = [];
      this.stopLossBuyRule = [];
      this.stopLossSellRule = [];
      // this.visibility = {
      //   postTo: "followers",
      //   groupId: null,
      // };
      this.switchValue = false;
      this.target_stop_loss_list = [
        {
          target_price: null,
          stop_loss: null,
        },
      ];
      this.trade_type_seg = "virtual";
      this.orderType = "market_order";
    },
    submitBtnHandler() {
      if (this.trade_type_seg === "virtual") {
        this.openReviewTrade();
      } else {
        this.postRealTrade();
      }
    },
    addNewTrailingStoploss() {
      this.$logEvent("add_intermediate_target_button");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_intermediate_target_button");
      }
      var item = {
        target_price: null,
        stop_loss: null,
      };
      if (this.target_stop_loss_list.length == 1) {
        item = {
          target_price: null,
          stop_loss: this.entry_price,
        };
      } else if (this.target_stop_loss_list.length > 1) {
        item = {
          target_price: null,
          stop_loss:
            this.target_stop_loss_list[this.target_stop_loss_list.length - 2]
              .target_price,
        };
      }

      this.target_stop_loss_list.push(item);
    },
    removeTrailingStopLoss(index) {
      this.target_stop_loss_list.splice(index, 1);
    },
    openReviewTrade() {
      this.rules = [(v) => !!v || "Required"];
      // console.log(this.$refs.tradeForm.validate());
      // console.log(
      //   this.entry_price,
      //   this.stop_loss,
      //   this.target_price,
      //   this.duration,
      //   this.securityData,
      //   this.reasoning,
      //   this.trade_type
      // );
      if (this.$refs.tradeForm.validate()) {
        this.target_price = this.target_stop_loss_list[0].target_price;
        this.stop_loss = this.target_stop_loss_list[0].stop_loss;

        var isValid = true;

        var self = this;

        console.log(this.target_stop_loss_list);

        this.target_stop_loss_list.every((element, index) => {
          var message = "";

          console.log(index);
          console.log(index == 0 && element.target_price > this.entry_price);

          console.log("1");

          console.log(element);

          // if (index !== 0) console.log(this.target_stop_loss_list[index - 1]);

          if (self.trade_type === "Buy") {
            if (index == 0 && element.target_price < self.entry_price) {
              isValid = false;
              message =
                "For Buy Trade, All targets should be greater than entry price and previous targets";
            } else if (
              index > 0 &&
              element.target_price <
                self.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Buy Trade, All targets should be greater than entry price and previous targets";
            }

            if (index == 0 && element.stop_loss >= self.entry_price) {
              isValid = false;
              message =
                "For Buy Trade, First stop-loss should be lesser than entry price and all other stop losses should be lesser than previous targets";
            } else if (
              index > 0 &&
              element.stop_loss >
                self.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Buy Trade, First stop-loss should be lesser than entry price and all other stop losses should be lesser than previous targets";
            }
          } else {
            if (index == 0 && element.target_price > this.entry_price) {
              isValid = false;
              message =
                "For Sell Trade, All targets should be lesser than entry price and previous targets";
            } else if (
              index > 0 &&
              element.target_price >
                this.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Sell Trade, All targets should be lesser than entry price and previous targets";
            }

            if (index == 0 && element.stop_loss <= this.entry_price) {
              isValid = false;
              message =
                "For Sell Trade, First stop-loss should be greater than entry price and all other stop losses should be greater than previous targets";
            } else if (
              index > 0 &&
              element.stop_loss <=
                this.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Sell Trade, First stop-loss should be greater than entry price and all other stop losses should be greater than previous targets";
            }
          }
          if (this.lots == 0 || !this.lots) {
            isValid = false;
            message = "For Posting a Trade Lots should be atleast 1";
          }

          if (!isValid) {
            this.snackBar({
              text: message,
              color: "error",
              timeout: 4500,
            });
            return false;
          } else {
            return true;
          }
        });

        if (!isValid) {
          return;
        }
        if (
          this.entry_price &&
          this.stop_loss &&
          this.target_price &&
          this.duration &&
          this.securityData &&
          this.trade_type
        ) {
          console.log("ellow orl");
          if (this.trade_type === "Buy") {
            if (this.entry_price) {
              if (
                !(
                  this.entry_price > this.stop_loss &&
                  this.entry_price < this.target_price
                )
              ) {
                this.snackBar({
                  text: "Entry Price Should be greater than stop loss and less than target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.target_price) {
              if (
                !(
                  this.target_price > this.stop_loss &&
                  this.target_price > this.entry_price
                )
              ) {
                this.snackBar({
                  text: "Target Price Should be greater than stop loss and  entry price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.stop_loss) {
              if (
                !(
                  this.stop_loss < this.entry_price &&
                  this.stop_loss < this.target_price
                )
              ) {
                this.snackBar({
                  text: "Stop loss should be less than entry price and target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
          } else if (this.trade_type === "Sell") {
            if (this.entry_price) {
              if (
                !(
                  this.entry_price > this.target_price &&
                  this.entry_price < this.stop_loss
                )
              ) {
                this.snackBar({
                  text: "Entry Price Should be greater than target price and less than stop loss",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.target_price) {
              if (
                !(
                  this.target_price < this.stop_loss &&
                  this.target_price < this.entry_price
                )
              ) {
                this.snackBar({
                  text: "Target price should be  smaller than stop loss and entry price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.stop_loss) {
              if (
                !(
                  this.stop_loss > this.entry_price &&
                  this.stop_loss > this.target_price
                )
              ) {
                this.snackBar({
                  text: "Stop loss should be greater than entry price and target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
          }
          if (this.visibility.postTo === "group" && !this.visibility.groupId) {
            this.snackBar({
              text: "Please select a group",
              color: "error",
              timeout: 4500,
            });

            return;
          }
          this.formLoading = true;
          const user_id = localStorage.getItem("profile_id");
          console.log(user_id, "user id");
          let data = {
            // entry_price: this.entry_price,
            // stop_loss: this.stop_loss,
            // target_price: this.target_price,
            // duration: this.duration.id,
            // duration_name: this.duration.name,
            // security_name: this.securityData.name,
            // security: this.securityData.id,
            // trade_type: this.trade_type,
            // reasonings: this.reasoning,
            // posted_by: user_id,
            // duration_type: this.duration_list,
            // target_stop_loss_list: [...this.target_stop_loss_list],
          };
          data["entry_price"] = this.entry_price;
          data["stop_loss"] = this.stop_loss;
          data["target_price"] = this.target_price;
          data["duration"] = this.duration;
          data["security_name"] = this.securityData.name;
          data["security"] = this.securityData.id;
          data["trade_type"] = this.trade_type;
          data["reasonings"] = this.reasoning;
          data["posted_by"] = user_id;
          data["duration_type"] = this.duration_list;
          if (this.type === "copy") {
            if (this.copyDetail.copy_origin) {
              data["copy_origin"] = this.copyDetail.copy_origin;
            } else {
              data["copy_origin"] = this.copyDetail.posted_by;
            }
          }
          data["lots"] = this.lots;
          if (this.visibility.postTo === "private") {
            data["is_trade_private"] = true;
          }
          let targetStopLoss = [];
          for (const obj of this.target_stop_loss_list) {
            if (obj.target_price && obj.stop_loss) {
              targetStopLoss.push(obj);
            }
          }
          data["target_stop_loss_list"] = [...targetStopLoss];

          console.log("trade review data", data);
          // this.$emit("trade-review", data);
          // this.closeForm();
          const successHandler = (res) => {
            this.snackBar({
              text: "Trade Posted Successfully",
              color: "success",
              timeout: 4500,
            });
            console.log(res);
            this.$emit("reloadTrades");

            this.formLoading = false;
            this.$logEvent("trade_posted");
            if (this.$vuetify.breakpoint.xsOnly) {
              this.$logEvent("mweb_trade_posted");
            }
            // this.trade_review_data.flag = false;
            this.closeForm();
          };

          const errorHandler = (err) => {
            this.snackBar({
              text: `${err.data.message}`,
              color: "error",
              timeout: 4500,
            });
            this.formLoading = false;
          };

          let url = "api/trade/create-trade/";
          if (this.visibility.postTo === "group") {
            url = `api/own-groups/${this.visibility.groupId}/post-trade/`;
          }

          Axios.request_POST(
            url,
            data,
            {},
            successHandler,
            errorHandler,
            false,
            true
          );
        }
      }
    },
    customFilter(item, queryText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.symbol.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      );
    },
    updateTrade() {
      this.target_price = this.target_stop_loss_list[0].target_price;
      this.stop_loss = this.target_stop_loss_list[0].stop_loss;
      if (this.trade_type === "Buy") {
        if (this.entry_price) {
          if (
            !(
              this.entry_price > this.stop_loss &&
              this.entry_price < this.target_price
            )
          ) {
            this.snackBar({
              text: "Entry Price Should be greater than stop loss and less than target price",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
        if (this.target_price) {
          if (
            !(
              this.target_price > this.stop_loss &&
              this.target_price > this.entry_price
            )
          ) {
            this.snackBar({
              text: "Target Price Should be greater than stop loss and  entry price",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
        if (this.stop_loss) {
          if (
            !(
              this.stop_loss < this.entry_price &&
              this.stop_loss < this.target_price
            )
          ) {
            this.snackBar({
              text: "Stop loss should be less than entry price and target price",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
      } else if (this.trade_type === "Sell") {
        if (this.entry_price) {
          if (
            !(
              this.entry_price > this.target_price &&
              this.entry_price < this.stop_loss
            )
          ) {
            this.snackBar({
              text: "Entry Price Should be greater than target price and less than stop loss",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
        if (this.target_price) {
          if (
            !(
              this.target_price < this.stop_loss &&
              this.target_price < this.entry_price
            )
          ) {
            this.snackBar({
              text: "Target price should be  smaller than stop loss and entry price",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
        if (this.stop_loss) {
          if (
            !(
              this.stop_loss > this.entry_price &&
              this.stop_loss > this.target_price
            )
          ) {
            this.snackBar({
              text: "Stop loss should be greater than entry price and target price",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
      }
      if (this.lots == 0 || !this.lots) {
        this.snackBar({
          text: "For Posting a Trade Lots should be atleast 1",
          color: "error",
          timeout: 4500,
        });
        return;
      }
      const successHandler = (res) => {
        console.log(res);
        this.snackBar({
          text: "Trade Updated successfully",
          color: "success",
          timeout: 4500,
        });
        this.$emit("reloadTrades");
        this.closeForm();
      };
      const errorHandler = (err) => {
        console.log(err, "err");
      };
      const data = {
        entry_price: this.entry_price,
        stop_loss: this.stop_loss,
        target_price: this.target_price,
        id: this.trade_data.id,
        target_stop_loss_list: this.target_stop_loss_list,
        trade_type: this.trade_type,
        lots: this.lots,
      };
      Axios.request_POST(
        `api/trade/update-trade-detail/`,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    postRealTrade() {
      this.rules = [(v) => !!v || "Required"];
      if (this.$refs.tradeForm.validate()) {
        this.target_price = this.target_stop_loss_list[0].target_price;
        this.stop_loss = this.target_stop_loss_list[0].stop_loss;

        var isValid = true;

        var self = this;

        this.target_stop_loss_list.every((element, index) => {
          var message = "";

          if (self.trade_type === "Buy") {
            if (index == 0 && element.target_price < self.entry_price) {
              isValid = false;
              message =
                "For Buy Trade, All targets should be greater than entry price and previous targets";
            } else if (
              index > 0 &&
              element.target_price <
                self.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Buy Trade, All targets should be greater than entry price and previous targets";
            }

            if (index == 0 && element.stop_loss >= self.entry_price) {
              isValid = false;
              message =
                "For Buy Trade, First stop-loss should be lesser than entry price and all other stop losses should be lesser than previous targets";
            } else if (
              index > 0 &&
              element.stop_loss >=
                self.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Buy Trade, First stop-loss should be lesser than entry price and all other stop losses should be lesser than previous targets";
            }
          } else {
            if (index == 0 && element.target_price > this.entry_price) {
              isValid = false;
              message =
                "For Sell Trade, All targets should be lesser than entry price and previous targets";
            } else if (
              index > 0 &&
              element.target_price >
                this.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Sell Trade, All targets should be lesser than entry price and previous targets";
            }

            if (index == 0 && element.stop_loss <= this.entry_price) {
              isValid = false;
              message =
                "For Sell Trade, First stop-loss should be greater than entry price and all other stop losses should be greater than previous targets";
            } else if (
              index > 0 &&
              element.stop_loss <=
                this.target_stop_loss_list[index - 1].target_price
            ) {
              isValid = false;
              message =
                "For Sell Trade, First stop-loss should be greater than entry price and all other stop losses should be greater than previous targets";
            }
          }
          if (this.lots == 0 || !this.lots) {
            isValid = false;
            message = "For Posting a Trade Lots should be atleast 1";
          }

          if (!isValid) {
            this.snackBar({
              text: message,
              color: "error",
              timeout: 4500,
            });
            return false;
          } else {
            return true;
          }
        });

        if (!isValid) {
          return;
        }
        if (
          this.entry_price &&
          this.stop_loss &&
          this.target_price &&
          this.duration &&
          this.securityData &&
          this.trade_type
        ) {
          if (this.trade_type === "Buy") {
            if (this.entry_price) {
              if (
                !(
                  this.entry_price > this.stop_loss &&
                  this.entry_price < this.target_price
                )
              ) {
                this.snackBar({
                  text: "Entry Price Should be greater than stop loss and less than target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.target_price) {
              if (
                !(
                  this.target_price > this.stop_loss &&
                  this.target_price > this.entry_price
                )
              ) {
                this.snackBar({
                  text: "Target Price Should be greater than stop loss and  entry price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.stop_loss) {
              if (
                !(
                  this.stop_loss < this.entry_price &&
                  this.stop_loss < this.target_price
                )
              ) {
                this.snackBar({
                  text: "Stop loss should be less than entry price and target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
          } else if (this.trade_type === "Sell") {
            if (this.entry_price) {
              if (
                !(
                  this.entry_price > this.target_price &&
                  this.entry_price < this.stop_loss
                )
              ) {
                this.snackBar({
                  text: "Entry Price Should be greater than target price and less than stop loss",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.target_price) {
              if (
                !(
                  this.target_price < this.stop_loss &&
                  this.target_price < this.entry_price
                )
              ) {
                this.snackBar({
                  text: "Target price should be  smaller than stop loss and entry price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
            if (this.stop_loss) {
              if (
                !(
                  this.stop_loss > this.entry_price &&
                  this.stop_loss > this.target_price
                )
              ) {
                this.snackBar({
                  text: "Stop loss should be greater than entry price and target price",
                  color: "error",
                  timeout: 4500,
                });
                return;
              }
            }
          }
          if (this.visibility.postTo === "group" && !this.visibility.groupId) {
            this.snackBar({
              text: "Please select a group",
              color: "error",
              timeout: 4500,
            });
            return;
          }
        }
      }
      this.realTradeLoading = true;
      const successHandler = (res) => {
        console.log(res, "real trade detail");
        this.executeSmallCaseFlow(res);
        this.realTradeLoading = false;
      };
      const failureHandler = () => {
        this.realTradeLoading = false;
      };
      const user_id = localStorage.getItem("profile_id");
      let data = {};
      data["entry_price"] = this.entry_price;
      data["stop_loss"] = this.stop_loss;
      data["target_price"] = this.target_price;
      data["duration"] = this.duration;
      data["security_name"] = this.securityData.name;
      data["security"] = this.securityData.id;
      data["trade_type"] = this.trade_type;
      data["reasonings"] = this.reasoning;
      data["posted_by"] = user_id;
      data["duration_type"] = this.duration_list;
      data["lots"] = this.lots;
      data["is_real"] = true;
      data["order_type"] = this.orderType;
      if (this.visibility.postTo === "private") {
        data["is_trade_private"] = true;
      }
      if (this.type === "copy") {
        if (this.copyDetail.copy_origin) {
          data["copy_origin"] = this.copyDetail.copy_origin;
        } else {
          data["copy_origin"] = this.copyDetail.posted_by;
        }
      }
      let targetStopLoss = [];
      for (const obj of this.target_stop_loss_list) {
        if (obj.target_price && obj.stop_loss) {
          targetStopLoss.push(obj);
        }
      }
      data["target_stop_loss_list"] = [...targetStopLoss];
      let url = "api/trade/create-trade/";
      if (this.visibility.postTo === "group") {
        url = `api/own-groups/${this.visibility.groupId}/post-trade/`;
      }

      Axios.request_POST(
        url,
        data,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    executeSmallCaseFlow(res) {
      console.log(res, res.data.id, "smallcase flow");

      let trade_id = res.data.id;
      let data = {};
      // data["trade_type"] = res.data.trade_type.toUpperCase();
      // data["security_symbol"] = res.data.security_symbol;
      // data["lots"] = res.data.lots;
      let headers = {};
      let params = {};
      params["trade_id"] = res.data.id;
      let config = {
        headers: headers,
        params: params,
      };
      this.tempAxios
        .post("trade", data, config)
        .then((res) => {
          console.log(res, "trade execution");
          this.triggerTransactionFLowSmallCase(
            res.data.resp.transactionId,
            res.data.auth_token,
            trade_id
          );
        })
        .catch((res) => {
          console.log(res, "trade execution error");
          this.deleteTrade(trade_id);
        });
    },
    triggerTransactionFLowSmallCase(transactionID, authToken, trade_id) {
      const self = this;
      const gatewayInstance = new window.scDK({
        // ! Use valid gateway name here
        gateway: "covesto",
        /*
         * ! Use valid auth token
         * Details - https://developers.gateway.smallcase.com/docs/getting-started#broker-identification
         */
        smallcaseAuthToken: authToken,
        config: {
          // Should allow after market orders?
          amo: true,
        },
      });

      gatewayInstance
        .triggerTransaction({
          // ! Use valid transactionId here
          transactionId: transactionID,
        })
        .then((txnResponse) => {
          /*
           * Gateway flow ended after order placement
           * Response structure & example - https://developers.gateway.smallcase.com/docs/transaction-response
           */
          console.log("received response:", txnResponse);
          // console.log(trade_id, "trade_id");
          commonFunctions.decode_smallcase_authtoken_and_send(
            txnResponse,
            trade_id
          );
          self.updateRealTrade(txnResponse, trade_id);
          self.reload();
          self.$emit("reloadTrades");
          self.closeForm();
        })
        .catch((err) => {
          /*
           * Gateway flow ended before order placement
           * Possible errors - https://developers.gateway.smallcase.com/docs/transaction-errors
           */
          console.log("received error:", err.message);
          this.deleteTrade(trade_id);
          this.closeForm();
        });
      // gatewayInstance.openSmallplug().then((res) => {
      //   console.log(res);
      // });
    },
    deleteTrade(id) {
      const failureHandler = () => {};
      const successHandler = () => {};
      let formData = {};
      formData["id"] = id;
      Axios.request_POST(
        apiUrl.DELETE_TRADE_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        false
      );
    },
    updateRealTrade(txnResponse, trade_id) {
      const successHandler = (res) => {
        console.log(res);
      };
      const failureHandler = () => {};
      let formData = {};
      formData["id"] = trade_id;
      if (txnResponse.orderBatches[0].orders[0].averagePrice) {
        formData["entry_price"] =
          txnResponse.orderBatches[0].orders[0].averagePrice;
      }
      if (txnResponse.orderBatches[0].orders[0].status === "COMPLETE") {
        formData["status"] = "Active";
      }
      Axios.request_PATCH(
        apiUrl.PATCH_TRADE_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    reload() {
      this.$emit("reload-trades");
      this.closeForm();
    },
    setEntryPrice() {
      if (this.orderType === "market_order") {
        this.entry_price = Number(this.sec_live_price);
      } else {
        this.entry_price = null;
      }
    },
    getLivePrice() {
      if (!this.securityData) {
        return false;
      }
      const successHandler = (res) => {
        console.log(res.data, "live price");
        this.sec_live_price = 0;
        this.sec_live_price = res.data.live_price.toFixed(2);
        this.sec_close_price = res.data.close_price.toFixed(2);
        this.entry_price = Number(this.sec_live_price);

        // this.target_stop_loss_list[0].stop_loss = Number(this.sec_live_price);
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      const data = {
        id: this.securityData.id || this.security,
      };
      Axios.request_POST(
        `api/trade/update-live-price/`,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    getModifyPrice() {
      if (!this.securityData) {
        return false;
      }
      const successHandler = (res) => {
        console.log(res.data, "live price");
        this.sec_live_price = 0;
        this.sec_live_price = res.data.live_price.toFixed(2);
        this.sec_close_price = res.data.close_price.toFixed(2);
        // this.entry_price = Number(this.sec_live_price);

        // this.target_stop_loss_list[0].stop_loss = Number(this.sec_live_price);
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      const data = {
        id: this.securityData.id || this.security,
      };
      Axios.request_POST(
        `api/trade/update-live-price/`,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    goToProfile(trade) {
      this.closeForm();
      this.$router.push({
        name: "OthersProfilePage",
        params: {
          id: trade.posted_by_id,
          name: trade.posted_by_name,
        },
      });
    },
    checkPrice() {
      // if(this.trade_type==='Buy'){
      //   this.tradeRules = {
      //      entry_price_buy: (value) =>
      //     (Number(this.stop_loss) <
      //       Number(value) <
      //       Number(this.target_price)) ||
      //     "Value should be greater than Stop Loss and smaller than Target Price",
      //     target_price_buy: (value) =>
      //     (Number(value) > Number(this.target_price) &&
      //       Number(value) > Number(this.stop_loss)) ||
      //     "Target Price should be greater than Stop Loss and Entry Price",
      //     stop_loss_buy: (value) =>
      //     ( Number(value)<  Number(this.entry_price) < Number(this.target_price)) ||
      //     "Value should be less than entry price and target price",
      //   }
      // }else if(this.trade_type==='Sell'){
      //   this.tradeRules={
      //   entry_price_sell: (value) =>
      //       (Number(this.stop_loss) <
      //         Number(value) <
      //         Number(this.target_price)) ||
      //       "Value should be greater than Target Price and smaller than Stop Loss",
      //     target_price_sell: (value) =>
      //       (Number(value) < Number(this.stop_loss) &&
      //         Number(value) < Number(this.target_price)) ||
      //       "Target Price should be smaller than Stop Loss and Entry Price",
      //     stop_loss_sell: (value) =>
      //       (Number(value) > Number(this.entry_price) &&
      //         Number(value) > Number(this.target_price)) ||
      //       "Value should be greater than entry price and target price ",
      //   }
      // }
      // this.rules = this.tradeRules
    },
    closeForm() {
      this.toggleTradeModal({ show: false });
    },
    getDurationList() {
      // this.loading = true;
      const successHandler = (res) => {
        this.duration_list = res.data;
        this.duration = this.duration_list[0].id;
      };
      const errorHanlder = (err) => {
        console.log(err);
        this.loading = false;
      };
      const finallyHandler = () => {
        if (this.type === "edit" || this.type === "copy") {
          this.getTradeDetail();
        } else if (this.type === "exit") {
          this.exitRealTradeSetup();
        } else {
          this.loading = false;
        }
      };
      Axios.request_GET(
        "api/trade/duration-list",
        {},
        {},
        successHandler,
        errorHanlder,
        false,
        false,
        finallyHandler
      );
    },
    exitRealTradeSetup() {
      const successHandler = (res) => {
        // console.log(res);
        this.switchValue = true;
        if (res.data.is_real) {
          this.trade_type_seg = "real";
        }
        this.securities.push({
          name: res.data.security_name,
          id: res.data.security,
        });
        this.securityData = {
          id: res.data.security,
          name: res.data.security_name,
        };
        this.getModifyPrice();
        this.entry_price = res.data.entry_price;
        this.lots = res.data.lots;
      };
      const errorHandler = () => {};
      Axios.request_GET(
        `api/trade/user-trade-detail/${this.trade_id}/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        true
      );
    },
    getTradeDetail() {
      const successHandler = (res) => {
        this.trade_data = res.data;
        console.log(this.trade_data, "trade data");
        this.securities.push({
          name: res.data.security_name,
          id: res.data.security,
        });
        // this.securityData["name"] = res.data.security_name
        this.securityData = {
          id: res.data.security,
          name: res.data.security_name,
        };
        this.getModifyPrice();
        if (
          (res.data.target_stop_loss_list.length && this.type === "edit") ||
          (res.data.target_stop_loss_list.length &&
            this.type === "copy" &&
            res.data.status !== "Closed")
        ) {
          this.entry_price = res.data.entry_price;
          this.target_stop_loss_list = res.data.target_stop_loss_list;
        } else if (
          this.type == "edit" ||
          (this.type === "copy" && res.data.status !== "Closed")
        ) {
          this.target_stop_loss_list = [
            {
              target_price: res.data.target_price,
              stop_loss: res.data.stop_loss,
            },
          ];
        } else {
          this.target_stop_loss_list = [
            {
              target_price: null,
              stop_loss: null,
            },
          ];
        }
        this.duration = res.data.duration;
        this.trade_type = res.data.trade_type;
        this.lots = res.data.lots;
        if (res.data.is_real) {
          this.trade_type_seg = "real";
        }
        if (res.data.trade_type === "Sell") {
          this.switchValue = true;
        }
        if (res.data.reasoning.content) {
          this.reasoning = res.data.reasoning.content;
        }
        setTimeout(() => {
          this.loading = false;
        }, 500);
      };
      const errorHandler = () => {
        this.loading = false;
      };
      Axios.request_GET(
        `api/trade/user-trade-detail/${this.trade_id}/`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        true
      );
    },
    searchSecruity() {
      this.isSearching = true;
      const successHandler = (res) => {
        this.securities = res.data;
        this.isSearching = false;
      };
      const errorHandler = (err) => {
        console.log(err);
        this.snackBar({
          text: `${err.data.message}`,
          color: "error",
          timeout: 4500,
        });
        this.isSearching = false;
      };
      Axios.request_POST(
        `api/security_search/${this.security}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    invokeTradeShare() {
      this.$emit("shareTrade", this.trade_data);
      setTimeout(() => {
        this.closeForm();
      }, 500);
    },
    setTradeType() {
      if (this.switchValue) {
        this.trade_type = "Sell";
      } else {
        this.trade_type = "Buy";
      }
      return true;
    },
  },
  mounted() {
    // console.log(this.groupId,"groupId in form",typeof(this.groupId))
    // if(this.this.groupId){
    //   this.visibility= {
    //   postTo: "followers",
    //   groupId: null,
    // },
    // }
    // console.log(this.$refs.tradeForm);
    var w = window.innerWidth;
    this.setTradeType();
    if (w < 768) {
      setTimeout(() => {
        this.fullscreen = true;
        this.hideOverlay = true;
      }, 100);
    } else {
      this.fullscreen = false;
      this.hideOverlay = false;
    }
    // console.log(this.trade_form_data.id, "trad eid");
    // this.getDurationList();
    // if (this.trade_form_data.id) {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.loading = false;
    //     // this.getLivePrice()
    //   }, 500);
    // }
    // if (this.trade_form_data.trade_edit) {
    //   console.log(this.trade_form_data.trade_data, "tank");
    //   this.securityData = this.trade_form_data.trade_data.security;
    //   this.securities.push = this.securityData;
    //   this.entry_price = this.trade_form_data.trade_data.entry_price;
    //   this.stop_loss = this.trade_form_data.trade_data.stop_loss;
    //   this.target_price = this.trade_form_data.trade_data.target_price;
    //   this.duration = {
    //     id: this.trade_form_data.trade_data.duration,
    //     name: this.trade_form_data.trade_data.duration_name,
    //   };
    //   this.duration_name = this.trade_form_data.trade_data.duration_name;
    //   this.security_name = this.securityData.name;
    //   this.security = this.trade_form_data.trade_data.security.name;
    //   this.trade_type = this.trade_form_data.trade_data.trade_type;
    //   this.reasoning = this.trade_form_data.trade_data.reasonings;
    //   this.posted_by = this.trade_form_data.trade_data.posted_by;
    //   this.duration_type = this.trade_form_data.trade_data.duration_type;
    //   // console.log(this.trade_data)
    //   this.getLivePrice();
    //   console.log(this.duration, "duration this is");
    // }
  },
};
</script>

<style scoped>
.copyOrigin {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;

  color: #000000;
  cursor: pointer;
}
.text__field {
  box-sizing: border-box;
  border-radius: 5px;
  margin-bottom: -20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 4px;
  margin-bottom: 0px !important;
}
.v-messages {
  flex: 1 1 auto;
  font-size: 12px;
  min-height: 0px !important;
  min-width: 1px;
  position: relative;
}
.v-radio >>> label {
  padding: 0px 0px !important;
}
.v-label {
  padding: 0px 0px !important;
}
.v-btn__content {
  width: 100% !important;
  white-space: normal !important;
}
div.v-dialog.v-dialog--active.v-dialog--scrollable {
  max-height: 90%;
  overflow: hidden !important;
  overflow-y: hidden !important;
}
.v-input--switch.track.theme--light {
  color: #2d8cff !important;
  caret-color: #2d8cff !important;
}
.buyStatusClass {
  color: #2d8cff;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}
.sellStatusClass {
  color: red;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}
.label {
  color: red;
  padding-bottom: 2px;
}

.text__col {
  margin-top: -15px;
  padding-left: 30px;
  padding-right: 30px;
}
.text__col1 {
  padding-left: 30px;
  padding-right: 30px;
}
.save__btn {
  text-transform: capitalize;
  color: #fff;
  width: 150px;
  letter-spacing: 0px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: bolder;
  height: 50px !important;
  margin-bottom: 20px;
  margin-right: 10px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
}
.tooltip-text {
  color: #111111 !important;
}
.title-color-sell {
  background-color: #eb5757;
}
.title-color-buy {
  background-color: #2d8cff;
}
.live-price-div {
  height: 46px;
}
.livePriceClass {
  color: #333333;
  font-size: 18px;
  font-weight: 700;
}
.stoploss_type__class {
  font-size: 13px;
  color: #2d8cff;
}
.sec-label-green {
  color: green;
}
.sec-label-red {
  color: red;
}
.buy-title {
  font-weight: bolder;
  color: #111111;
}
div.v-input--switch__track {
  background-color: #2d8cff;
  color: #2d8cff;
}

.sell-title {
  color: #111111;
  font-weight: bolder;
}

@media all and (max-width: 600px) {
  .change__input__text {
    font-size: 12px !important;
  }
  .text__col {
    margin-top: -15px;
    padding-left: 20px;
    padding-right: 20px;
  }
}

/* raw switch*/
*,
*:before,
*:after {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, ".SFNSText-Regular", "Helvetica Neue", "Roboto",
    "Segoe UI", sans-serif;
}

.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #2d8cff;
  border-radius: 16px;
  width: 55px;
  height: 31px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch:before,
.toggle-switch:after {
  content: "";
}
.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: #eb5757;
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}
/* raw switch*/
</style>

<style>
.v-radio > .v-label {
  padding: 0px 10px;
}
.v-text-field--outlined fieldset {
  border: 0.5px solid rgba(0, 0, 0, 0.16) !important;
}
.custom-switch .v-input--selection-controls__input div {
  color: #2d8cff;
}
</style>
